import { formatToMonthDayYear } from "@workspace/lib/date";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@workspace/web-ui/components/table"

export interface MedicationsTableProps {
  cardTitle: string;
  data: {
    medication: string,
    price: string,
    prescribed_date: string,
    refills: string,
    status: string
  }[]
}

const MedicationsTable = ({ data, cardTitle }: MedicationsTableProps) => {
  return (
    <div className="flex flex-col gap-4 pb-4 bg-white rounded-lg border border-[#E6E6E6] shadow-sm">
      <div className="px-6 py-4 flex gap-2 border-b border-[#DCDCDE] w-full">
        <h2 className="text-lg font-medium text-[#2D2F35] text-left">{cardTitle}</h2>
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Medication</TableHead>
              <TableHead>Price</TableHead>
              <TableHead>Prescribed Date</TableHead>
              <TableHead>Refills</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{item.medication}</TableCell>
                <TableCell>{item.price}</TableCell>
                <TableCell>{ formatToMonthDayYear(item.prescribed_date)}</TableCell>
                <TableCell>{item.refills}</TableCell>
                <TableCell>
                  <span className={`px-2 py-1 rounded-full text-xs ${item.status === 'Paid' ? 'bg-green-100 text-green-500' :
                    item.status === 'Pending' ? 'bg-yellow-100 text-yellow-500' :
                      'bg-red-100 text-red-500'
                    }`}>
                    {item.status}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default MedicationsTable